var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagePlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 57,
    viewBox: "0 0 100 57",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#image_placeholder_svg__clip0_88_39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 28l27.28 28.5H-.236L27.5 28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 17l38.5 39.75H23.894L62 17z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 12,
    r: 7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "image_placeholder_svg__clip0_88_39"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h100v56.25H0z"
  })))));
}
export default SvgImagePlaceholder;